import Model, { attr, hasMany, type AsyncHasMany } from '@ember-data/model';
import type GroupModel from 'garaje/models/group';

/**
 * Slimmed JSON:API resource backing the blocklist location picker (GET /api/v3/blacklist-locations)
 * and the `locations` relationship on blacklist-filter — deliberately minimal, distinct from the full
 * `location` model. `disabled` marks an inactive location (greyed in the picker).
 */
export default class BlacklistLocation extends Model {
  @attr('string', { defaultValue: () => null }) declare name: string | null;
  @attr('boolean', { defaultValue: () => false }) declare disabled: boolean;

  @hasMany('group', { async: true, inverse: null }) declare groups: AsyncHasMany<GroupModel>;
}

declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'blacklist-location': BlacklistLocation;
  }
}
